import styled from "styled-components";
import { breakpoints } from "../../../../constants/media";

const Container = styled.div`
  width: 287px;
  margin: 0px 0px 0px 0px;
  display: flex;
  justify-content: flex-start;

  // Card Container
  .card-container {
    width: calc(100% - 48px);
    margin: 0px 0px 0px 0px;
    padding: 24px;
    border-radius: 12px;
    border: 1px solid var(--grisClaro);
    box-shadow: 0px 0px 40px rgba(0, 52, 253, 0.07);

    // Data Container
    #data-container {
      width: 100%;
    }
  }

  // Logo Title Container & Text Button Container
  #logo-title-container,
  #text-button-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  // Logo
  #logo-title-container img {
    width: auto;
    height: 30px;
    margin: 0px 0px 0px 0px;
    pointer-events: none;
  }

  // Title
  #logo-title-container p {
    width: 95%;
    margin: 24px 0px 0px 0px;
    font-weight: 500;
    font-size: 14px;
    line-height: 154.7%;
    letter-spacing: -0.015em;
    color: #666666;
    pointer-events: none;
  }

  // Text
  #text-button-container p {
    width: 80%;
    height: 36.04px;
    margin: 24px 0px 0px 0px;
    font-weight: 400;
    font-size: 12px;
    line-height: 154.7%;
    letter-spacing: -0.015em;
    color: #9f9fa1;
    pointer-events: none;
  }

  // Button
  #text-button-container a {
    margin: 24px 0px 0px 0px;
    padding: 12px 24px 12px 24px;
    background-color: #f4f7fd;
    border-radius: 6px;
    border: 0;
    font-weight: 600;
    font-size: 13px;
    line-height: 154.7%;
    text-align: center;
    letter-spacing: -0.015em;
    color: var(--azul100);
    transition: 0.2s all;
  }

  // Button Hover
  #text-button-container a:hover {
    background-color: #e2ebfc;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    width: 306.6px;

    // Card Container
    .card-container {
      width: calc(100% - 49px);
      margin-left: 1px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    width: 320px;

    // Card Container
    .card-container {
      width: calc(100% - 48px);
      margin-left: 0px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    width: 480px;
    justify-content: center;
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    width: 350px;
  }
`;

export default Container;
